export default __webpack_public_path__ + "static/media/7.12a6cca6.png";